(function () {
  function buildTikTokCartHandoffUrl(cart, origin, rootPath = '/') {
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      throw new Error('Your cart is empty.');
    }

    const lines = cart.items.map((item) => {
      const variantId = String(item.variant_id ?? '').trim();
      const quantity = Number(item.quantity);

      if (!/^\d+$/.test(variantId) || !Number.isInteger(quantity) || quantity < 1) {
        throw new Error('Your cart contains an invalid item.');
      }

      return `${variantId}:${quantity}`;
    });

    const normalizedRoot = rootPath.startsWith('/') ? rootPath : '/';
    const root = normalizedRoot.endsWith('/') ? normalizedRoot : `${normalizedRoot}/`;
    const url = new URL(`${root}cart/${lines.join(',')}`, origin);

    url.searchParams.set('storefront', 'true');
    url.searchParams.set('utm_source', 'tiktok');
    url.searchParams.set('utm_medium', 'organic_video');
    url.searchParams.set('utm_campaign', 'tiktok_live_us');
    url.searchParams.set('utm_content', 'browser_handoff');
    url.searchParams.set('ref', 'tiktok_live_us_handoff');

    return url.toString();
  }

  async function fetchCurrentCart(rootPath) {
    const normalizedRoot = rootPath.endsWith('/') ? rootPath : `${rootPath}/`;
    const response = await fetch(`${normalizedRoot}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error('Unable to read your cart.');
    return response.json();
  }

  function bindTikTokCartHandoff() {
    const link = document.querySelector('[data-tiktok-cart-handoff]');
    if (!link) return;

    const status = document.querySelector('[data-tiktok-cart-handoff-status]');
    const rootPath = window.Shopify?.routes?.root || '/';
    let pendingPreparation = null;

    const prepare = () => {
      if (pendingPreparation) return pendingPreparation;

      delete link.dataset.tiktokCartHandoffReady;
      pendingPreparation = fetchCurrentCart(rootPath)
        .then((cart) => buildTikTokCartHandoffUrl(cart, window.location.origin, rootPath))
        .then((targetUrl) => {
          link.href = targetUrl;
          link.dataset.tiktokCartHandoffReady = 'true';
          return targetUrl;
        })
        .finally(() => {
          pendingPreparation = null;
        });

      return pendingPreparation;
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => prepare().catch(() => false));
    }

    link.addEventListener('click', async (event) => {
      if (link.dataset.tiktokCartHandoffReady === 'true') return;

      event.preventDefault();
      link.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Preparing your cart...';

      try {
        const targetUrl = await prepare();
        window.location.assign(targetUrl);
      } catch (error) {
        link.removeAttribute('aria-busy');
        if (status) status.textContent = 'Unable to prepare your cart. Please try again.';
      }
    });
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { buildTikTokCartHandoffUrl };
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindTikTokCartHandoff, { once: true });
    } else {
      bindTikTokCartHandoff();
    }
  }
})();
